import { defineMessages } from 'react-intl';

export default defineMessages({
  ordersTitle: {
    id: 'clinic-orders.header',
    defaultMessage: 'Orders',
  },
  emptyStateTitle: {
    id: 'clinic-orders.empty-state.title',
    defaultMessage: 'No orders found',
  },
  emptyStateSubtitle: {
    id: 'clinic-orders.empty-state.subtitle',
    defaultMessage: 'This clinic has no orders yet. Create a new order to get started.',
  },
  orderIdColumn: {
    id: 'clinic-orders.order-id-column',
    defaultMessage: 'SO ID',
  },
  externalReferenceColumn: {
    id: 'clinic-orders.external-reference-column',
    defaultMessage: 'PO ID',
  },
  statusColumn: {
    id: 'clinic-orders.status-column',
    defaultMessage: 'Status',
  },
  totalPriceColumn: {
    id: 'clinic-orders.total-price-column',
    defaultMessage: 'Total Price',
  },
  actionsColumn: {
    id: 'clinic-orders.actions-column',
    defaultMessage: 'Actions',
  },
  newOrderTitle: {
    id: 'clinic-orders.new-order',
    defaultMessage: 'New Order',
  },
  saveBtnLabel: {
    id: 'clinic-orders.save-btn',
    defaultMessage: 'Save order',
  },
  itemsCardTitle: {
    id: 'clinic-orders.items-card-title',
    defaultMessage: 'Products',
  },
  productDescriptionColumn: {
    id: 'clinic-orders.product-description-column',
    defaultMessage: 'Description',
  },
  missingProductDescription: {
    id: 'clinic-orders.missing-product-description',
    defaultMessage: 'Missing product description',
  },
  productIdColumn: {
    id: 'clinic-orders.product-id-column',
    defaultMessage: 'Ref',
  },
  quantityColumn: {
    id: 'clinic-orders.quantity-column',
    defaultMessage: 'Quantity',
  },
  priceColumn: {
    id: 'clinic-orders.price-column',
    defaultMessage: 'Price',
  },
  totalColumn: {
    id: 'clinic-orders.total-column',
    defaultMessage: 'Total',
  },
  subtotalLabel: {
    id: 'clinic-orders.subtotal-label',
    defaultMessage: 'Subtotal',
  },
  subtotalDisclaimer: {
    id: 'clinic-orders.subtotal-disclaimer',
    defaultMessage: '*Does not include VAT charges and shipping costs which may be applicable',
  },
  balloonRatioWarning: {
    id: 'clinic-orders.balloon-ratio-warning',
    defaultMessage:
      'Warning: Device ({deviceSkus}), filler kit ({fillerKitSku}), and scale ({scaleSku}) are usually ordered together in a 1:1:1 ratio.',
  },
  shippingInformationCardTitle: {
    id: 'clinic-orders.shipping-address-card-title',
    defaultMessage: 'Shipping information',
  },
  addressLineLabel: {
    id: 'clinic-orders.shipping-address-label',
    defaultMessage: 'Address',
  },
  phoneNumberLabel: {
    id: 'clinic-orders.phone-number-label',
    defaultMessage: 'Phone number',
  },
  emailLabel: {
    id: 'clinic-orders.email-label',
    defaultMessage: 'Email',
  },
  shippingInstructionsLabel: {
    id: 'clinic-orders.shipping-instructions-label',
    defaultMessage: 'Shipping instructions',
  },
  expressServiceLabel: {
    id: 'clinic-orders.express-service-label',
    defaultMessage: 'Express Service (up to 4 working days)',
  },
  economyServiceLabel: {
    id: 'clinic-orders.economy-service-label',
    defaultMessage: 'Economy Service (up to 7 working days)',
  },
  expectedDeliveryDateLabel: {
    id: 'clinic-orders.expected-delivery-date-label',
    defaultMessage: 'Expected delivery date',
  },
  billingInformationCardTitle: {
    id: 'clinic-orders.billing-address-card-title',
    defaultMessage: 'Billing information',
  },
  vatIdLabel: {
    id: 'clinic-orders.vat-id-label',
    defaultMessage: 'VAT Identification Number',
  },
  vatIdHelp: {
    id: 'clinic-orders.vat-id-help',
    defaultMessage: 'Please provide your VAT Identification Number, in case it changed',
  },
  overallDiscountLabel: {
    id: 'clinic-orders.overall-discount-label',
    defaultMessage: 'Overall discount (%)',
  },
  overallDiscountHelp: {
    id: 'clinic-orders.overall-discount-help',
    defaultMessage:
      'If you have an overall discount to apply to the order, please enter the percentage value here (e.g. enter 10 for a 10% discount). This will be applied to the entire order total.',
  },
  additionalInstructionsCardTitle: {
    id: 'clinic-orders.additional-instructions-card-title',
    defaultMessage: 'Additional instructions',
  },
  notesLabel: {
    id: 'clinic-orders.notes-label',
    defaultMessage: 'Notes',
  },
  notesHelp: {
    id: 'clinic-orders.notes-help',
    defaultMessage: 'Please provide any additional instructions or notes for the order',
  },
  externalReferenceLabel: {
    id: 'clinic-orders.external-reference-label',
    defaultMessage: 'Purchase Order Number',
  },
  externalReferenceHelp: {
    id: 'clinic-orders.external-reference-help',
    defaultMessage: 'Use this field for internal reference with external systems',
  },
  termsAndConditionsText: {
    id: 'clinic-orders.terms-and-conditions-text',
    defaultMessage: 'Terms and Conditions applicable to this Purchase Order can be reviewed at',
  },
  errorSubmittingOrder: {
    id: 'clinic-orders.error-submitting-order',
    defaultMessage: 'It was not possible to submit the order. Please try again later.',
  },
  orderCreated: {
    id: 'clinic-orders.order-created',
    defaultMessage: 'Order created successfully.',
  },
});
